var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-container",
    [
      _c(
        "b-row",
        [
          _c("b-col", [
            _c("p", { staticClass: "mt-4" }, [
              _c(
                "span",
                {
                  staticClass:
                    "text-uppercase fw-600 grey-color text-decoration-none fs-14",
                },
                [_vm._v("44-ФЗ ")]
              ),
              _c("ul", { staticClass: "full_menu-list" }, [
                _c(
                  "li",
                  { staticClass: "list-item" },
                  [
                    _c(
                      "router-link",
                      {
                        attrs: {
                          exact: "",
                          to: {
                            name: "Fl44NoticesList",
                            params: { status: "accepting" },
                          },
                        },
                      },
                      [_vm._v("Извещения")]
                    ),
                  ],
                  1
                ),
                _c(
                  "li",
                  { staticClass: "list-item" },
                  [
                    _c(
                      "router-link",
                      {
                        class:
                          _vm.$route.matched[0]?.path === "/contracts/fl44" &&
                          "router-link-active",
                        attrs: {
                          to: {
                            name: "ContractsList",
                            params: { contract: "all" },
                          },
                        },
                      },
                      [_vm._v("Контракты")]
                    ),
                  ],
                  1
                ),
              ]),
            ]),
            _c("p", { staticClass: "mt-4" }, [
              _c(
                "span",
                {
                  staticClass:
                    "text-uppercase fw-600 grey-color text-decoration-none fs-14",
                },
                [_vm._v("223-ФЗ ")]
              ),
              _c("ul", { staticClass: "full_menu-list" }, [
                _c(
                  "li",
                  { staticClass: "list-item" },
                  [
                    _c(
                      "router-link",
                      {
                        class:
                          _vm.$route.matched[0]?.path === "/notices/fl223" &&
                          "router-link-active",
                        attrs: {
                          to: {
                            name: "Fl223NoticesList",
                            params: { status: "accepting" },
                          },
                        },
                      },
                      [_vm._v("Извещения")]
                    ),
                  ],
                  1
                ),
              ]),
            ]),
            _c("p", { staticClass: "mt-4" }, [
              _c(
                "span",
                {
                  staticClass:
                    "text-uppercase fw-600 grey-color text-decoration-none fs-14",
                },
                [_vm._v("КОММЕРЧЕСКИЕ ")]
              ),
              _c("ul", { staticClass: "full_menu-list" }, [
                _c(
                  "li",
                  { staticClass: "list-item" },
                  [
                    _c(
                      "router-link",
                      {
                        class:
                          _vm.$route.matched[0]?.path ===
                            "/notices/commercial" && "router-link-active",
                        attrs: {
                          to: {
                            name: "CommercialNoticesList",
                            params: { status: "accepting" },
                          },
                        },
                      },
                      [_vm._v("Извещения")]
                    ),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
          _c("b-col", [
            _c(
              "p",
              { staticClass: "text-uppercase fw-600 grey-color fs-14 mt-4" },
              [
                _c(
                  "router-link",
                  {
                    staticClass:
                      "text-uppercase fw-600 grey-color text-decoration-none fs-14",
                    attrs: { to: "/organizations" },
                  },
                  [_vm._v("Организации")]
                ),
              ],
              1
            ),
            _c(
              "p",
              { staticClass: "mt-4" },
              [
                _c(
                  "router-link",
                  {
                    staticClass:
                      "text-uppercase fw-600 grey-color text-decoration-none fs-14",
                    attrs: { to: "/quotation-requests" },
                  },
                  [_vm._v("Запросы КП")]
                ),
              ],
              1
            ),
            _c(
              "p",
              { staticClass: "mt-4" },
              [
                _c(
                  "router-link",
                  {
                    staticClass:
                      "text-uppercase fw-600 grey-color text-decoration-none fs-14",
                    attrs: {
                      to: {
                        name: "ImportSubstitutionRequestsList",
                        params: { path: "open" },
                      },
                    },
                  },
                  [_vm._v("Импортозамещение ")]
                ),
              ],
              1
            ),
          ]),
          _c("b-col", [
            _c(
              "p",
              {
                staticClass:
                  "text-uppercase fw-600 grey-color fs-14 mt-4 text-nowrap",
              },
              [
                _c(
                  "a",
                  {
                    staticClass:
                      "atmo-link-off text-uppercase fw-600 grey-color text-decoration-none fs-14",
                    attrs: {
                      href: _vm.$links.telegram_channel,
                      target: "_blank",
                    },
                  },
                  [
                    _vm._v(" Новости "),
                    _c("b-icon", {
                      staticStyle: { color: "#229ed9" },
                      attrs: { icon: "telegram" },
                    }),
                  ],
                  1
                ),
              ]
            ),
            _c(
              "p",
              { staticClass: "text-uppercase fw-600 grey-color fs-14 mt-4" },
              [
                _c(
                  "a",
                  {
                    staticClass:
                      "atmo-link-off text-uppercase fw-600 grey-color text-decoration-none fs-14",
                    attrs: {
                      href: _vm.$links.info_materials,
                      target: "_blank",
                    },
                  },
                  [_vm._v(" ИНФОРМАЦИОННЫЕ МАТЕРИАЛЫ ")]
                ),
              ]
            ),
            _c(
              "p",
              { staticClass: "text-uppercase fw-600 grey-color fs-14 mt-4" },
              [
                _c(
                  "a",
                  {
                    staticClass:
                      "atmo-link-off text-uppercase fw-600 grey-color text-decoration-none fs-14",
                    attrs: {
                      href: _vm.$links.legal_documents,
                      target: "_blank",
                    },
                  },
                  [_vm._v(" Правовые документы ")]
                ),
              ]
            ),
          ]),
          _c("b-col", [
            _c(
              "p",
              {
                staticClass:
                  "text-uppercase fw-600 grey-color text-decoration-none fs-14 mt-4",
              },
              [_vm._v("Режим работы")]
            ),
            _c("ul", { staticClass: "full_menu-list" }, [
              _c("li", { staticClass: "list-item" }, [
                _c("p", { staticClass: "grey-color fs-14" }, [
                  _vm._v(
                    "9:00 до 18:00 (по времени г. " + _vm._s(_vm.city) + ")"
                  ),
                ]),
              ]),
            ]),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }